import React, { useContext, useState, useEffect, useRef } from 'react';
import { Table } from 'rsuite';
import {
  Button,
  ActionLink,
  CommonToaster,
} from '../../atoms';
import { default as t } from '../../../utils/i18n';
import { ReactComponent as ConfigureIcon } from '../../../assets/svg/configure.svg';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/trash-outline.svg';
import { ReactComponent as KebabIcon } from '../../../assets/svg/kebab.svg';
import { ReactComponent as SaveIcon } from '../../../assets/svg/save.svg';
import { ReactComponent as DisabledSaveIcon } from '../../../assets/svg/save_dark_grey.svg';

import { ToasterContext, UserContext } from '../../../context';
import './report-breakdown-table.scss';
import RightModal from '../../atoms/right-modal/right-modal';
import ReportConfigure from '../report-configure/report-configure';
import { ReportsService } from '../../../services';
import { useDrag, useDrop, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useHistory } from 'react-router-dom';
import { ModalWindow, SelectedCampaignsContainer, AppTooltip } from '../../atoms';

const ReportBreakdownTable = ({
  activeStep,
  setActiveStep,
  stepperData,
  setStepperData,
  draftReportId,
}) => {
  const { Column, HeaderCell, Cell } = Table;
  const [openSliderModal, setOpenSliderModal] = useState(false);
  const [data, setData] = useState([]);
  const { user, setUser } = useContext(UserContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const [breakdownAttribute, setBreakdownAttribute] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [canCreateList, setCanCreateList] = useState(true);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const history = useHistory();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [goToNext, setgoToNext] = useState(true);
  const [showDeleteAttributeModal, setShowDeleteAttributeModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [existingData, setExistingData] = useState({});
  const [savedOrdered, setSavedOrdered] = useState([]);

  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);

  const TYPE = useRef(null);
  const [name, setName] = useState('');
  const reportId = draftReportId ? draftReportId : stepperData?.data?.data?.reportId;

  const ItemTypes = {
    COLUMN: 'column',
    ROW: 'row',
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (draftReportId && user?.isSaveDraft) {
      let msg = t('mgs.success.saveStep');
      setTheMessages({ message: msg, isError: false });
    }
    getBreakdownList();
    getReportDetails();
  }, []);

  const handleClick = async (e, isSaveDraft) => {
    try {
      let breakDownTable = [];
      data?.forEach((item, index) => {
        breakDownTable.push({
          _id: item.id,
          tableTitle: item.breakDownName,
          attributes: [...item.sysId],
          order: index + 1,
          timeIncrement: item.sysId.includes('week') ? 7 : item.sysId.includes('month') ? 30 : null,
        });
      });

      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
        attributes: [...breakdownAttribute],
      }));

      const payload = {
        breakdowns: breakDownTable,
        "reportName": user?.reportName
      };
      const reportResponse = await ReportsService.updateReportDetails(
        userAccessToken,
        username,
        payload,
        reportId,
        isSaveDraft
      );
      const reportData = reportResponse?.data?.data;
      if (reportData && !isSaveDraft) {
        setActiveStep(activeStep + 1);
      }

    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  };

  const handleBackClick = () => {
    setIsBackClicked(true);
    setShowCancelModal(true);
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };
  const handleOnCancel = e => {
    e.preventDefault();
    setShowDeleteAttributeModal(false);
  };
  const handleOnCloseDeleteModal = () => {
    setShowDeleteAttributeModal(false);
  };

  const handleOnConfirm = async () => {
    handleDeleteState(deleteId);
    setShowDeleteAttributeModal(false);
  };

  const handleOpenSliderModal = (param, obj, orderedAttributes, orderedAttr) => {
    orderedAttributes = [];
    obj?.forEach(res => {
      if(res?.isChecked) {
        orderedAttributes?.push(res)
      }
    })
    if (orderedAttr?.length > 0) {
      let attr_sysId = orderedAttr.filter(item => item.isChecked).map(attr => attr.sys_id);
      let attr_name = orderedAttr.filter(item => item.isChecked).map(attr => attr.name);
      data.forEach(x => {
        if (x.id === selectedRow.id) {
          x.attributes = [...attr_name];
          x.sysId = [...attr_sysId];
          x.isConfigureIcon = x?.status === 'EDIT' ? true : false;
        }
      });
      setData([...data]);
      setSavedOrdered(orderedAttr);
    }
    setOpenSliderModal(!openSliderModal);
  };

  function addRows() {
    focusOnDiv();
    setSelectedRow(null);
    const item = {
      id: data.length.toString(),
      breakDownName: '',
      attributes: [],
      sysId: [],
      isSelected: false,
      isConfigureIcon: true,
      status: 'EDIT',
    };

    setData([...data, item]);
    setgoToNext(true);
  }

  function getAttributeName(idArray) {
    const name = [];
    breakdownAttribute?.length > 0 &&
      breakdownAttribute?.forEach(idx => {
        idArray?.length > 0 &&
          idArray?.forEach(id => {
            if (idx.sys_id === id) {
              name.push(idx.name);
            }
          });
      });
    return name.length > 0 ? name : idArray;
  }

  async function getReportDetails() {
    try {
      const response = await ReportsService.getReportDetailsByReportID(
        userAccessToken,
        username,
        //  'MIA1LIVJUDUX'
        reportId
      );
      TYPE.current = response?.data?.data?.type;
      const reportData = response?.data?.data.reportBreakdown.map(list => ({
        id: list._id,
        breakDownName: list.tableTitle,
        attributes: [...list.attributes],
        sysId: [...list.attributes],
        isSelected: false,
        order: list.order,
      }));
      let attributesVal = response?.data?.data.reportBreakdown?.some(
        val => val?.attributes?.length > 0
      );
      setgoToNext(!attributesVal);
      reportData?.sort((a, b) => (a.order > b.order ? 1 : -1));
      reportData?.forEach(val => {
        if(val?.id && val?.attributes?.length <=0) {
          val.isConfigureIcon = true;
          val.status = "EDIT"
        }
      })
      setData(reportData);
      setExistingData({ ...response?.data?.data });
      setUser(prevUser => ({
        ...user,
        selectedAdvertiser: response?.data?.data?.advertiser,
        selectedAdaccounts: response?.data?.data?.campaigns[0]?.accountId,
        reportType: response?.data?.data?.type
      }));
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  async function getBreakdownList() {
    try {
      const response = await ReportsService.getBreakdownList(userAccessToken, username);
      const reportData = response?.data?.data;
      reportData.forEach(data => ((data.isChecked = false), (data.isDisabled = false)));
      setBreakdownAttribute(reportData);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  async function removeBreakdown(_id) {
    try {
      const response = await ReportsService.deleteBreakdown(userAccessToken, username, _id);
      const result = response?.data?.data;
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find(item => item.id === id)[key] = value;
     setData([...nextData]);
  };
  const handleEditState = id => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find(item => item.id === id);
    if (activeItem.breakDownName && activeItem.attributes) {
      activeItem.status = activeItem.status ? null : 'EDIT';
      setData(nextData);
      if (activeItem.status !== 'EDIT') {
        setgoToNext(checkNextButtonValidation(nextData));
      } else {
        setgoToNext(true);
      }
      activeItem.isConfigureIcon = activeItem.status === 'EDIT' ? true : false;
    } else {
      setgoToNext(true);
    }
  };

  const handleDeleteState = id => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.filter(item => item.id !== id);
    setData(activeItem);
    setgoToNext(checkNextButtonValidation(activeItem));
    if (id.length > 5) {
      removeBreakdown(id);
    }
  };

  function checkData(selectedRow) {
    if (TYPE.current === 'LIVE') {
      const pos = breakdownAttribute.findIndex(el => el.sys_id === 'month');
      if (pos >= 0) breakdownAttribute.splice(pos, 1);
      setBreakdownAttribute(breakdownAttribute);
    }
    if (selectedRow?.attributes?.length === 0) {
      breakdownAttribute.forEach(data => ((data.isChecked = false), (data.isDisabled = false)));
      setBreakdownAttribute(breakdownAttribute);
      setCanCreateList(true);
    } else {
      for (const idx of breakdownAttribute) {
        for (const sys of selectedRow?.sysId) {
          if (idx?.sys_id === sys) {
            idx.isChecked = true;
            if (idx?.invalid_combination?.length > 0) {
              getInvalidAttributes(idx?.invalid_combination);
            }
            break;
          } else {
            idx.isChecked = false;
          }
        }
      }
      setBreakdownAttribute(breakdownAttribute);
      const breakdownChecked = breakdownAttribute.some(idx => idx.isChecked);
      setCanCreateList(!breakdownChecked);
    }
  }

  function getInvalidAttributes(attr) {
    breakdownAttribute?.forEach(idx => {
      attr?.forEach(element => {
        if (idx.sys_id === element) {
          idx.isDisabled = true;
        }
      });
    });
  }

  function checkNextButtonValidation(arrayToCheck) {
    return arrayToCheck.length > 0 ? arrayToCheck.some(ele => ele.status === 'EDIT') : true;
  }

  function Row({ children, onDrag, id, rowData, ...rest }) {
    const ref = React.useRef(null);

    const [{ canDrop, isOver }, drop] = useDrop({
      accept: ItemTypes.ROW,
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
      drop(item, monitor) {
        onDrag && onDrag(item.id, rowData.id);
      },
    });

    const [{ isDragging }, drag] = useDrag({
      item: { id: rowData.id },
      type: ItemTypes.ROW,
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    });
    const isActive = canDrop && isOver;

    drag(drop(ref));

    const styles = {
      cursor: 'grab',
      opacity: isDragging ? 0.5 : 1,
      background: isActive ? '#ddd' : null,
      width: '100%',
      height: '100%',
      borderTop: isActive ? '2px solid #2589f5' : null,
    };

    return (
      <div ref={ref} style={styles}>
        {children}
      </div>
    );
  }

  function sort(source, sourceId, targetId) {
    const nextData = source.filter(item => item.id !== sourceId);
    const dragItem = source.find(item => item.id === sourceId);
    const index = nextData.findIndex(item => item.id === targetId);

    nextData.splice(index, 0, dragItem);
    return nextData;
  }

  const handleDragRow = (sourceId, targetId) => {
    setData(sort(data, sourceId, targetId));
  };

  const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
    const editing = rowData.status === 'EDIT';
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <input
          id={rowData?.id}
            placeholder={t('define.breakdown.table.input.placeholder')}
            className="rs-input"
            defaultValue={rowData[dataKey]}
            onBlur={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        ) : (
          <span className="table-content-edit-span" title={rowData[dataKey]}>{rowData[dataKey]}</span>
        )}
      </Cell>
    );
  };

  const onClickOfConfigureInEdit = (res) => {
    let selectedRowAttr = []
    res?.sysId?.forEach(val => {
      breakdownAttribute.forEach(attr => {
        if(val === attr?.sys_id) {
          selectedRowAttr.push(attr)
        }
      })
    })
    setSavedOrdered([...selectedRowAttr]);
    setOpenSliderModal(!openSliderModal)
  }

  const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
    const attributes = getAttributeName(rowData?.attributes);
    return (
      <Cell {...props} style={{ padding: '6px', display: 'flex', gap: '15px' }}>
        {rowData?.isConfigureIcon && (
          <button className="configure-button" onClick={() => onClickOfConfigureInEdit(rowData)}>
            <ConfigureIcon style={attributes?.length > 0 ? {} : { marginRight: '5px' }} />
            {rowData?.attributes?.length > 0 ? (
              ''
            ) : (
              <span>{t('define.breakdown.table.btn.configure')}</span>
            )}
          </button>
        )}
        <span>{rowData?.attributes && attributes?.join('  ,  ')}</span>
      </Cell>
    );
  };

  const handleCancelClick = e => {
    e.preventDefault();
    setShowCancelModal(true);
    setIsBackClicked(false);
  };

  const handleOnCloseCancelModal = () => {
    setShowCancelModal(false);
    setIsBackClicked(false);
  };

  const onContinue = e => {
    e.preventDefault();
    setShowCancelModal(false);
    setUser(prevUser => ({
      ...user,
      isSaveDraft: false,
    }));
    if (isBackClicked) {
      setActiveStep(activeStep - 1);
    } else {
      if(user?.isFirstTimeCreation) {
        handleDeleteReport({reportId: reportId})
      } else {
        history.push('/reports');
      }
    }
  };

  async function handleDeleteReport(payload) {
    try {
      const deleteRes = await ReportsService.deleteReport(
        userAccessToken,
        username,
        payload
      );
      const delResponse = deleteRes.data?.data;
      if(delResponse.message === "Successfully Updated"){
        setUser(prevUser => ({
          ...user,
          isFirstTimeCreation: false,
        }));
      }
      history.push('/reports');
    } catch (error) {
      setUser(prevUser => ({
        ...user,
        isFirstTimeCreation: false,
      }));
      history.push('/reports');
    }
  }

  const onSaveDraft = (e) => {
    e.preventDefault();
    handleClick('', true);
    if (isBackClicked) {
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
      }));
      setActiveStep(activeStep - 1);
    } else {
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
      }));
      history.push('/reports');
    }
    setShowCancelModal(false);
  };

  const onCancelReq = () => {
    setIsBackClicked(false);
    setShowCancelModal(false);
  };

  function focusOnDiv() {
    const divElement = document.getElementById('table');
    divElement.focus();
  }

  const setTheMessages = (message) => {
    if (message?.message) {
      setMessage({});
      setMessage(message);
      setToaster(true);
      clearToaster();
    } else {
      setToaster(false);
      setMessage({});
    }
  };


  let clearToaster = () => {
    setTimeout(() => {
      setToaster(false);
    }, 7000);
  };

  return (
    <div className="breakdown-table">
      <div className={toaster ? 'toasterTop' : ''}>
        <CommonToaster message={message} toaster={toaster}></CommonToaster>
      </div>
      <div className='exit'>
        <button className="step-cancel" onClick={handleCancelClick}>
          {t('report.client.reporting.exit')}
        </button>
      </div>
      <div className="flexbox">
        <div className="break-down-header">
          <h3>{t('define.breakdown.table.header')}</h3>
        </div>
        <div className="right-modal-toggle-btn" label="addRow" onClick={addRows}>
          <i className="eva eva-plus-outline plus-icon"></i>
          <p>{t('define.breakdown.btn.addRow')}</p>
        </div>
      </div>
      <p>{t('define.breakdown.table.discription')}</p>
      <SelectedCampaignsContainer selectedCampaigns={existingData}></SelectedCampaignsContainer>

      <div tabindex="0" id="table" className="table-container">
        <DndProvider backend={HTML5Backend}>
          <Table
            height={400}
            bordered
            data={data}
            locale={{ emptyMessage: t('define.breakdown.table.emptyMgs') }}
            onRowClick={rowData => {
              setSelectedRow(null);
              rowData.isSelected = true;
              setSelectedRow(rowData);
              checkData(rowData);
            }}
            renderRow={(children, rowData) => {
              return rowData ? (
                <Row key={rowData.id} rowData={rowData} id={rowData.id} onDrag={handleDragRow}>
                  {children}
                </Row>
              ) : (
                children
              );
            }}
          >
            <Column width={getWidth(25)}>
              <HeaderCell></HeaderCell>
              <Cell dataKey="id">
                <KebabIcon />
                <KebabIcon />
              </Cell>
            </Column>
            <Column width={getWidth(4)} align="left" fixed>
              <HeaderCell>{t('define.breakdown.table.tableTitle')} <span className='imp-icon'>*</span></HeaderCell>
              <EditableCell dataKey="breakDownName" onChange={handleChange} />
            </Column>

            <Column width={getWidth(3)} align="left" fixed>
              <HeaderCell>{t('define.breakdown.table.breakDownAttributes')} <span className='imp-icon'>*</span></HeaderCell>
              <ActionCell dataKey="attributes" />
            </Column>

            <Column width={getWidth(4)} flexGrow={1} align="right" fixed>
              <HeaderCell>{t('define.breakdown.table.action')}</HeaderCell>

              <Cell>
                {rowData => {
                  function handleEditAction() {
                    handleEditState(rowData.id);
                  }
                  function handleAction() {
                    setShowDeleteAttributeModal(true);
                    setDeleteId(rowData.id);
                    let val = data?.some(res => res?.attributes?.length > 0);
                    setgoToNext(val);
                  }
                  return (
                    <span className="action">
                      <a onClick={handleAction}>
                        {' '}
                        <DeleteIcon className="icon-size delete-icon" />{' '}
                      </a>
                      <a onClick={handleEditAction}>
                        {' '}
                        {rowData.status === 'EDIT' ? (
                           rowData?.breakDownName && rowData?.breakDownName!== ''  && rowData?.attributes?.length ? (
                            <SaveIcon className="icon-size save-svg" />
                          ) : (
                            <DisabledSaveIcon
                              className="icon-size"
                              onClick={e => e.preventDefault()}
                            />
                          )
                        ) : (
                          <EditIcon className="icon-size" />
                        )}{' '}
                      </a>
                    </span>
                  );
                }}
              </Cell>
            </Column>
          </Table>
        </DndProvider>
      </div>

      <div className="btn-steps">
        <button
          className="step-back"
          disabled={activeStep === 0}
          label="Back"
          onClick={handleBackClick}
        >
          {t('define.report.stepper.button.back')}
        </button>
        <span
          className="step-next"
          data-tip={goToNext ? t('define.breakdown.next.btn.tooltip') : ''}
          data-for="tool-tip3"
        >
          <button
            className={goToNext ? 'step-next disabled' : 'step-next'}
            onClick={handleClick}
            label="Next"
            disabled={goToNext}
          >
            {t('define.report.stepper.button.next')}
          </button>
        </span>
        <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip3" place="left" />
      </div>
      {openSliderModal && (
        <RightModal openSliderModal={openSliderModal}>
          <ReportConfigure
            attributes={breakdownAttribute}
            data={selectedRow}
            canCreateList={canCreateList}
            setCanCreateList={setCanCreateList}
            handleOpenSliderModal={handleOpenSliderModal}
            savedOrdered={savedOrdered}
          />
        </RightModal>
      )}

      <div className="report-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showCancelModal}
          onRequestClose={handleOnCloseCancelModal}
          heading={
            !isBackClicked ? t('define.stepper.cancel.heading') : t('define.stepper.back.heading')
          }
          ariaHideApp={false}
        >
          <p className="fqa-model-showanswer--message message-font">
            {!isBackClicked
              ? t('define.stepper.cancel.request')
              : t('define.stepper.back.subHeading')}
          </p>
          <p></p>
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={!isBackClicked ? t('define.stepper.save') : t('define.stepper.back.save')}
              handleClick={onSaveDraft}
            />
            <ActionLink
              anchor={true}
              value={
                !isBackClicked
                  ? t('define.stepper.cancel.continue')
                  : t('define.stepper.back.continue')
              }
              handleClick={onContinue}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              label={t('define.stepper.cancel')}
              handleClick={onCancelReq}
            />
          </div>
        </ModalWindow>
      </div>
      <div className="attr-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showDeleteAttributeModal}
          onRequestClose={handleOnCloseDeleteModal}
          heading={t('define.breakdown.row.delete')}
          ariaHideApp={false}
          appElement={document.getElementById('app')}
        >
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={t('reportTable.campaign.delete.cancel')}
              handleClick={handleOnCancel}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              label={t('reportTable.campaign.delete')}
              handleClick={handleOnConfirm}
            />
          </div>
        </ModalWindow>
      </div>
    </div>
  );
};

export default ReportBreakdownTable;
